import { Inputs } from '../../../../types/Enums';
import {
  InputComponentsConfigType,
  InputConfig,
} from '../../../../types/ConfigTypes';
import AdvisoryInputComponentsConfig, {
  fullWidthConfig,
} from '../../advisory-flow/config/inputComponentsConfig';

/**
 * CONFIGS
 */
const defaultConfig: InputConfig = {
  styling: {
    justifySelf: 'center',
    w: '100%',
  },
  config: {
    isTitleHidden: false,
  },
  gridConfig: {
    isFullScreen: false,
  },
};

const amountConfig: InputConfig = {
  ...defaultConfig,
  styling: {
    justifySelf: 'center',
    w: 'auto',
  },
  config: {
    isTitleHidden: true,
  },
  gridConfig: {
    isExpandedGrid: true,
  },
};

// Here you can specify a custom config for certain Input types
const InputComponentsConfig: InputComponentsConfigType = {
  ...AdvisoryInputComponentsConfig,
  [Inputs.MULTISELECT]: fullWidthConfig,
  [Inputs.AMOUNT]: amountConfig,
};

export default InputComponentsConfig;
